/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query CreditReadQuery($customerId: ID!) {
    CreditRead(customerId: $customerId) {
      id,
      limit,
      balance,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
